import React, { useState, useRef, useCallback} from "react";
import Webcam from "react-webcam";
const videoConstraints= {
        height: 300,
        width: 300,
        facingMode: "user"
    };

export default function WebCam ({onCapture}){
    const webcamRef = React.useRef(null);
    const [preview, setPreview] = useState("");
    const capture = React.useCallback(
        () => {
            const imageSrc = webcamRef.current.getScreenshot();
            setPreview(imageSrc);
            onCapture(imageSrc);
        }, [webcamRef, onCapture]
    );
    return (
    <div>
        <Webcam
        audio={false}
        ref={webcamRef}
        screenshotFormat="image/jpeg"
        videoConstraints={videoConstraints}
       />    
        <button onClick={capture}
        className="bg-blue-500 text-white px-3 py-1 mt-2 rounded">
        capture photo</button>
        
        {preview && (
            <img src ={preview} alt="preview" className="mt-2 w-32 rounded" />
        )}
        
    </div>
    );
}